import { Link } from 'react-router-dom'
import SEOHead from '../components/SEOHead'
import { useCmsPage } from '../hooks/useCmsPage'

export default function AboutPage() {
  const { page } = useCmsPage('om-os')

  const title = page?.meta_title || 'DJ udlejning  — Casper DJ'
  const description =
    page?.meta_description ||
    'DJ udlejning med CasperDJ. I årevis har jeg lagt lyd til firmafester, konfirmationer, intime fejringer, storslåede bryllupper og privatfester., DJ udlejning med CasperDJ. I årevis har jeg lagt lyd til firmafester, konfirmationer, intime fejringer, storslåede bryllupper og privatfester.  '

  return (
    <div className="bg-neutral-950 text-white min-h-screen">
      <SEOHead title={title} description={description} />

      {/* Hero Header */}
      <section className="pt-32 pb-16 md:pt-48 md:pb-24 border-b border-neutral-900 bg-neutral-900/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Image */}
            <div className="lg:col-span-5">
              <div className="relative aspect-square rounded-3xl overflow-hidden border border-neutral-800 shadow-2xl bg-neutral-900 group">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/bce4b86c-87d9-405d-a99b-f30b07aaa8a2/28208-a.jpg"
                  alt="Casper DJ bag mixerpulten"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <div className="absolute bottom-4 left-4 right-4 text-center text-xs text-neutral-400 font-medium">
                  Casper DJ — Professionelt udstyr og musik
                </div>
              </div>
            </div>

            {/* Copy */}
            <div className="lg:col-span-7 space-y-6">
              <span className="text-xs font-semibold tracking-widest text-gold-400 uppercase">
                DJ Udlejning
              </span>
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-white leading-tight">
                KVALITET TIL DIN FEST
              </h1>

              <div className="space-y-4 text-neutral-300 leading-relaxed text-sm sm:text-base">
                <p>
                  I årevis har jeg lagt lyd til{' '}
                  <Link to="/firmafest" className="text-gold-400 hover:underline font-medium">
                    firmafester
                  </Link>
                  , konfirmationer, intime fejringer, storslåede{' '}
                  <Link to="/bryllup" className="text-gold-400 hover:underline font-medium">
                    bryllupper
                  </Link>
                  ,{' '}
                  <Link to="/privatfest" className="text-gold-400 hover:underline font-medium">
                    privatfester
                  </Link>
                  , som runde fødselsdage og diverse events i Odense og resten af Danmark. Det har gjort mig til ekspert i at skræddersy musikken, så lydbilledet bakker op om festens tema og den ønskede stemning.
                </p>

                <p>
                  Det er min fornemmeste opgave at sætte gang i dansegulvet og sikre den gode stemning, så du kan læne sig tilbage og nyde din fest. Lyd-udstyret er professionelt til både til små og store events, og lydkvaliteten er altid i top. Jeg har beliggenhed i Odense, men jeg spiller i hele Danmark efter aftale.
                </p>

                <p>
                  En god fest er en positiv samlende oplevelse og som DJ til festen sikrer{' '}
                  <Link to="/" className="text-gold-400 hover:underline font-medium">
                    CasperDJ
                  </Link>{' '}
                  at festen bliver, som i ønsker den. &nbsp;Vi kan tilpasse musik og setup til alle former for arrangementer, små som store.
                </p>

                <p>
                  Et hvilket som helst setup er muligt, og ønsker i en fest der virkelig skiller sig ud fra de andre, giver vi gerne inspiration til temfester og setup.
                </p>
              </div>

              <div className="pt-4 flex flex-wrap items-center gap-4">
                <Link
                  to="/kontakt"
                  className="px-8 py-3.5 bg-gold-400 text-neutral-950 font-bold text-sm uppercase tracking-wider rounded-xl hover:bg-gold-300 transition-colors shadow-lg cursor-pointer"
                >
                  Kontakt
                </Link>
                <Link
                  to="/faa-et-tilbud"
                  className="px-6 py-3.5 border border-neutral-800 bg-neutral-900 text-white font-bold text-sm uppercase tracking-wider rounded-xl hover:border-gold-400/50 hover:text-gold-400 transition-colors cursor-pointer"
                >
                  Få et tilbud
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services summary */}
      <section className="py-20 bg-neutral-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-xl mx-auto mb-12">
            <span className="text-xs font-semibold tracking-widest text-gold-400 uppercase">
              Udforsk mulighederne
            </span>
            <h2 className="text-2xl sm:text-3xl font-extrabold text-white mt-1">
              Musik tilpasset enhver anledning
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Link
              to="/firmafest"
              className="p-6 rounded-2xl bg-neutral-900/50 border border-neutral-800 hover:border-gold-400/50 transition-colors group flex flex-col justify-between"
            >
              <div>
                <span className="text-gold-400 text-xs font-bold uppercase tracking-wider">01 / Firma</span>
                <h3 className="text-xl font-bold text-white group-hover:text-gold-400 mt-2 transition-colors">
                  DJ til Firmafest
                </h3>
                <p className="text-neutral-400 text-sm mt-2 leading-relaxed">
                  Skab den perfekte ramme om årets firmafest, sommerfest eller julefrokost.
                </p>
              </div>
              <span className="mt-6 text-xs font-bold text-gold-400 uppercase tracking-wider flex items-center gap-1">
                <span>Læs mere</span>
                <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
              </span>
            </Link>

            <Link
              to="/privatfest"
              className="p-6 rounded-2xl bg-neutral-900/50 border border-neutral-800 hover:border-gold-400/50 transition-colors group flex flex-col justify-between"
            >
              <div>
                <span className="text-gold-400 text-xs font-bold uppercase tracking-wider">02 / Privat</span>
                <h3 className="text-xl font-bold text-white group-hover:text-gold-400 mt-2 transition-colors">
                  DJ til Privatfest
                </h3>
                <p className="text-neutral-400 text-sm mt-2 leading-relaxed">
                  Fødselsdag, konfirmation, jubilæum eller havefest med god musik og stemning.
                </p>
              </div>
              <span className="mt-6 text-xs font-bold text-gold-400 uppercase tracking-wider flex items-center gap-1">
                <span>Læs mere</span>
                <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
              </span>
            </Link>

            <Link
              to="/bryllup"
              className="p-6 rounded-2xl bg-neutral-900/50 border border-neutral-800 hover:border-gold-400/50 transition-colors group flex flex-col justify-between"
            >
              <div>
                <span className="text-gold-400 text-xs font-bold uppercase tracking-wider">03 / Bryllup</span>
                <h3 className="text-xl font-bold text-white group-hover:text-gold-400 mt-2 transition-colors">
                  DJ til Bryllup
                </h3>
                <p className="text-neutral-400 text-sm mt-2 leading-relaxed">
                  En magisk og problemfri dag med musik tilpasset gæster og brudepar.
                </p>
              </div>
              <span className="mt-6 text-xs font-bold text-gold-400 uppercase tracking-wider flex items-center gap-1">
                <span>Læs mere</span>
                <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
              </span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}
